"use client";

import { useState } from "react";
import { ApprovalType } from "@zapier/utils";
import { FolderTreeItem, HydratedZapAsset, Zap } from "@zapier/client";
import { ZapModal } from "../components/zaps/types";
import { FolderModal } from "../types";

/** This hook manages state for folder and Zap modals that appear as siblings to
 * Folder and Zap tables in the UI.
 */

export function useFolderAndZapsModalStates() {
  const [currentZapModal, setCurrentZapModal] = useState<
    ZapModal | undefined
  >();
  const [currentFolderModal, setCurrentFolderModal] = useState<
    FolderModal | undefined
  >();
  const [approvalType, setApprovalType] = useState<ApprovalType | undefined>();
  const [currentZap, setCurrentZap] = useState<
    Zap | HydratedZapAsset | undefined
  >();
  const [currentFolder, setCurrentFolder] = useState<
    FolderTreeItem | undefined
  >();

  return {
    approvalType,
    currentFolder,
    currentFolderModal,
    currentZap,
    currentZapModal,
    setApprovalType,
    setCurrentFolder,
    setCurrentFolderModal,
    setCurrentZap,
    setCurrentZapModal,
  };
}
